import React, { createContext, useContext } from 'react';
import { useSimpleAuth } from '../../features/auth/hooks/useSimpleAuth';
import { AuthContextValue } from '../../core/types/auth.types'; // ← Import unified type

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const SimpleAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useSimpleAuth() as AuthContextValue;

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextValue => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within SimpleAuthProvider');
  }
  return context;
};